import { connect } from 'react-redux';
import LaporanAbsensiPegawaiDetail from '../../../views/Personnel/Absensi/LaporanAbsensiPegawaiDetail.absensi.view';
import { getAssignment } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAssignment: payload => dispatch(getAssignment(payload)),
  };
}

export default connect(null, mapDispatchToProps)(LaporanAbsensiPegawaiDetail);